(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gitlab-config', {
            parent: 'admin',
            url: '/gitlab-config',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'gitlabConfig.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/gitlab-config/gitlab-config.html',
                    controller: 'GitLabConfigController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gitlabConfig');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
